const BRANDS = [
    "Candy",
    "Hotpoint Ariston",
    "Whirlpool",
    "Electrolux",
    "AEG",
    "Beko",
    "Bosch",
    "Samsung",
    "Indesit",
    "Vorwerk",
    "Folletto",
];

function Track({ hidden = false }) {
    return (
        <div
            className="flex shrink-0 items-center"
            aria-hidden={hidden || undefined}
        >
            {BRANDS.map((b, i) => (
                <span key={b} className="flex items-center">
                    <span
                        className={`font-display text-3xl md:text-5xl font-black tracking-tighter uppercase whitespace-nowrap ${
                            i % 2 === 0 ? "text-foreground" : "text-outline-faint"
                        }`}
                    >
                        {b}
                    </span>
                    <span className="mx-8 md:mx-12 h-2.5 w-2.5 rotate-45 bg-primary shrink-0" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section className="border-y border-line py-6 md:py-8 overflow-hidden bg-background/60">
            <div className="marquee-track flex w-max animate-marquee">
                <Track />
                <Track hidden />
            </div>
        </section>
    );
}